<div class="route-component">
    <tab-control>
        <tab-page title="Details" icon="fas fa-user-pen">
            <div class="form-component">
                <div class="form-header">
                    <h4 *ngIf="endorsementId === 0">Create Endorsement</h4>
                    <h4 *ngIf="endorsementId > 0 && !inViewMode">Edit Endorsement</h4>
                    <h4 *ngIf="endorsementId > 0 && inViewMode">View Endorsement</h4>
                </div>

                <form #form="ngForm" (ngSubmit)="onSave(form)">

                <div>
                    <!-- Endorsement Type -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="endorsementTypes"
                            [label]="'Endorsement Type:'"
                            [placeholder]="'Select an endorsement type...'"
                            [initialValue]="selectedEndorsementTypeId"
                            [required]="true"
                            [invalid]="!selectedEndorsementTypeId && formSubmitted"
                            [validationMessage]="'Endorsement Type is required'"
                            [disabled]="inViewMode"
                            [displayWith]="displayEndorsementType"
                            (selectionChange)="onEndorsementTypeSelectionChange($event)">
                        </auto-complete-dropdown>
                        <!-- Hidden input for form validation -->
                        <input type="hidden" name="endorsementTypeId" [(ngModel)]="selectedEndorsementTypeId" required />
                    </div>

                    <!-- Dynamic Input Field For Values-->
                    <div class="input-group" *ngIf="selectedInputType">
                        <label for="values">{{ selectedEndorsementType }}:</label>

                        <!-- Rand Input -->
                        <div *ngIf="selectedInputType === 'rand'" class="input-with-symbol">
                            <span class="symbol">R</span>
                            <input
                                type="number"
                                id="values"
                                name="values"
                                [(ngModel)]="endorsement.values"
                                [disabled]="inViewMode"
                                step="0.01"
                                min="0"
                                required/>
                        </div>

                        <!-- Number Input -->
                        <div *ngIf="selectedInputType === 'number'">
                            <input
                                type="number"
                                id="values"
                                name="values"
                                [(ngModel)]="endorsement.values"
                                [disabled]="inViewMode"
                                step="0.01"
                                min="0"
                                required/>
                        </div>

                        <!-- Percent Input -->
                        <div *ngIf="selectedInputType === 'percent'" class="input-with-symbol">
                            <input
                                type="number"
                                id="values"
                                name="values"
                                [(ngModel)]="endorsement.values"
                                [disabled]="inViewMode"
                                step="0.1"
                                min="0"
                                max="100"
                                required/>
                            <span class="symbol">%</span>
                        </div>

                        <!-- Multiline Text Input -->
                        <textarea *ngIf="selectedInputType === 'multiline-text'"
                            id="values"
                            name="values"
                            [(ngModel)]="endorsement.values"
                            [disabled]="inViewMode"
                            rows="5"
                            cols="40"
                            required>
                        </textarea>

                        <!-- Text Input -->
                        <input *ngIf="selectedInputType === 'text'"
                            type="text"
                            id="values"
                            name="values"
                            placeholder="0.00"
                            [(ngModel)]="endorsement.values"
                            [disabled]="inViewMode"
                            required/>

                        <!-- Dropdown Input -->
                        <auto-complete-dropdown *ngIf="selectedInputType === 'dropdown'"
                            [options]="endorsementTypeValues"
                            [label]="''"
                            [placeholder]="'Select a value...'"
                            [initialValue]="selectedEndorsementTypeValueId"
                            [required]="true"
                            [displayWith]="displayEndorsementTypeValue"
                            [disabled]="inViewMode"
                            (selectionChange)="onEndorsementTypeValueSelectionChange($event)">
                        </auto-complete-dropdown>
                        <!-- Hidden input for form validation when dropdown is active -->
                        <input *ngIf="selectedInputType === 'dropdown'" type="hidden" name="endorsementTypeValueId" [(ngModel)]="selectedEndorsementTypeValueId" required />
                    </div>
                </div>

                    <!-- Effective Date -->
                    <div class="input-group">
                        <label for="effectiveDate">Effective Date:<span class="required"> * </span></label>
                        <div>
                            <input
                                type="date"
                                id="effectiveDate"
                                name="effectiveDate"
                                #effectiveDate="ngModel"
                                [class.invalid]="effectiveDate.invalid"
                                [disabled]="inViewMode"
                                [(ngModel)]="endorsement.effectiveDate"
                                (input)="onExpiryDateInput()"
                                required/>
                            <div *ngIf="effectiveDate.invalid">
                                <span class="error">Effective date is required</span>
                            </div>
                        </div>
                    </div>

                    <!-- Expiry Date -->
                    <div class="input-group">
                        <label for="expiryDate">Expiry Date:</label>
                        <input
                            type="date"
                            id="expiryDate"
                            name="expiryDate"
                            #expiryDate="ngModel"
                            [class.invalid]="expiryDate.invalid"
                            [(ngModel)]="endorsement.expiryDate"
                            (input)="onExpiryDateInput()"
                            [disabled]="inViewMode"
                            required/>
                        <div *ngIf="expiryDateError">
                            <span class="error">The Expiry Date cannot be set to a date before the Effective Date</span>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid || isSaving" [hidden]="inViewMode">
                            <span *ngIf="isSaving" class="loading-spinner"></span>
                            <i *ngIf="!isSaving" class="fas fa-save"></i>
                            Save
                        </button>
                        <button type="button" class="button-cancel" (click)="onCancel()">
                            <i class="fas fa-cancel"></i> Clear
                        </button>
                        <button type="button" class="button-back" (click)="onBack()">
                            <i class="fas fa-arrow-left"></i> Back To Policy
                        </button>
                    </div>
                </form>
            </div>
        </tab-page>
    </tab-control>
</div>
